module.exports = __webpack_public_path__ + "static/r11-93221858a64a52ab3edf0368ceee65a5.jpg";